export default () => ({
  showModal: false,
  agenda_id: null,
  agenda: {
    address: {},
    schedules: []
  }
})



// WEBPACK FOOTER //
// ./src/app/employee/dashboard/gadget/components/active-agenda/resources/data.js